/** Clés réservées au parcours joueur (ne pas toucher au back-office, ex. teamlab_admin_token). */
const PLAYER_SESSION_KEYS = ['session_code', 'team_name', 'team_id', 'current_round', 'last_verbatim'] as const;

export function clearPlayerSessionStorage(): void {
  for (const key of PLAYER_SESSION_KEYS) {
    localStorage.removeItem(key);
  }
}
